import MasterCrudPage from '../../components/MasterCrudPage';

export default function DesignationGroups() {
  return (
    <MasterCrudPage
      config={{
        title: 'Designation Group',
        apiBase: '/masters/designation-groups',
        listKey: 'designationGroups',
        entityKey: 'designationGroup',
        fields: [{ key: 'customTitle', label: 'Custom Title', type: 'text', maxLength: 50 }],
      }}
    />
  );
}
